import { render } from "./Recall.vue?vue&type=template&id=e2a90362&scoped=true"
import script from "./Recall.vue?vue&type=script&lang=js"
export * from "./Recall.vue?vue&type=script&lang=js"

import "./Recall.vue?vue&type=style&index=0&id=e2a90362&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2a90362"]])

export default __exports__